import {
  LOADING_STATES,
  ARTICLES_GET_REQUEST,
  ARTICLES_GET_SUCCESS,
  ARTICLES_GET_FAILURE,
  ARTICLES_DELETE_SUCCESS,
  ARTICLES_CANCEL,
  ARTICLES_ADD_TO_LIST,
  ARTICLES_REMOVE_FROM_LIST,
} from 'data/constants';

const defaultState = {
  state: LOADING_STATES.INITIAL,
  count: 0,
  list: [],
  error: null,
};

export default function articlesList(state = defaultState, action) {
  switch (action.type) {
    case ARTICLES_GET_REQUEST:
      return {
        ...state,
        state: LOADING_STATES.LOADING,
      };
    case ARTICLES_GET_SUCCESS:
      return {
        ...state,
        state: LOADING_STATES.LOADED,
        count: action.data.meta.total_count,
        list: action.data.articles,
      };
    case ARTICLES_GET_FAILURE:
      return {
        ...state,
        state: LOADING_STATES.FAILED,
        error: action.error.message,
      };
    case ARTICLES_ADD_TO_LIST:
      if (state.state !== LOADING_STATES.INITIAL) {
        return {
          ...state,
          count: state.count + 1,
          list: [
            action.article,
            ...state.list,
          ],
        };
      }
      return state;
    case ARTICLES_DELETE_SUCCESS:
    case ARTICLES_REMOVE_FROM_LIST:
      return {
        ...state,
        count: state.count - 1,
        list: state.list.filter(article => article.slug !== action.meta.slug),
      };
    case ARTICLES_CANCEL:
      return defaultState;
    default:
      return state;
  }
}
